import Dashboard from "@/pages/Dashboard";

export const ROUTES = {
    AUTH: {
        LOGIN: "/login",
        SIGNUP: "/onboarding",
        SIGNUP_OTP: "/onboarding/verify-otp",
        FORGOT_PASSWORD: "/forgot-password",
    },
    MAIN: {
        DASHBOARD: "/",
        CREATEPROJECT: "/create-project",
        ESCROW: "/escrow-account",
        TEAM: "/team-access-control",
        ANALYTICS: "/analytics",
        LEADS: "/leads",
        PROJECTS: "/projects",
        PROJECT_DETAILS: "/projects/:projectId",
        CREATE_PROPERTY: "/projects/:projectId/create-property",
        PROJECT_PROPERTY_DETAILS: "/projects/:projectId/properties/:propertyId",
        PROPERTIES: "/properties",
        INQUIRIES: "/inquiries",
        MEDIA_AND_VISUALS: "/media-manager",
        PROPERTY_DETAILS: "/properties/:id",
        SUBSCRIPTION: "/subscription",
        PAYMENT: "/payment",
        PAYMENTS_DASHBOARD: "/payments-dashboard",
        ONBOARDING_KYC: "/onboarding/kyc",
        ONBOARDING_SIGNATORY: "/onboarding/authorized-signatory",
    },
    BOTTOM: {
        SETTINGS: "/settings",
        INFO: "/info",
    }

} as const;
